module.exports = __webpack_public_path__ + "static/media/infoJumbo3.d3e0ef91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/nordlock/images/infoJumbo3.jpg
// module id = 551
// module chunks = 0